import styled from 'styled-components';

const StatusBadge = styled.span`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  background-color: ${props => {
    switch (props.status) {
      case 'active':
        return '#10b981';
      case 'paused':
        return '#f59e0b';
      case 'failed':
        return '#ef4444';
      case 'running':
        return '#3b82f6';
      default:
        return '#6b7280';
    }
  }};
  color: white;
  display: inline-block;
`;

const JobStatusBadge = ({ status }) => {
  const statusLabels = {
    active: 'Active',
    paused: 'Paused',
    failed: 'Failed',
    running: 'Running',
  };

  return (
    <StatusBadge status={status}>
      {statusLabels[status] || status}
    </StatusBadge>
  );
};

export default JobStatusBadge;

